import Env from '../env'
import {support, handle} from '../core'
import {compareVersion, onceIn} from '../utils'

// TODO 换掉 DIDI 全局变量

const noop = () => {}

/**
 * 新增js bridge 接口在export中增加配置项即可。
 * 调用方法如：dbridge.xxx，其中xxx为方法列表的key
 * 配置项包括：
 * name：FE与native RD协商的接口名称。若无name项，则默认为列表key
 * alias：接口别名，多个别名用"|"分隔，每个别名也可以用dbridge.xxx形式调用。别名调用方式是为了向前兼容，不推荐此种调用方式
 * support：native从哪个版本开始支持该接口，值为字符串或者数组
 *   如：'2.4.4'即表示iOS APP和android APP均从2.4.4版本开始支持；
 *   [{type: 'android', version: '2.4.4'}]表示android APP从2.4.4支持，iOS不支持。
 *   prepare：自定义处理函数，主要用于抹平iOS和Android司机端实现差异，接受两个可选参数，返回结果为数组，格式如[String fnName, JSON params, function cb]，
 **/
// kf一期support版本统一改成0.0.0
// 验证过的bridge注释标注了 // kfI-done
export default {
    shareWeixinAppmsg: {
        alias: 'weixinAppmsg|shareWeixinAppmsg|share_weixin_appmsg|weixin_appmsg',
        support: '0.0.0',
        prepare: function (params, cb) {
            let conf = {
                url: params.url || params.share_url,
                icon: params.icon || params.icon_url || params.share_icon_url || params.imageUrl || params.share_img_url,
                title: params.title || params.share_title,
                desc: params.desc || params.content || params.share_content || params.descript
            }
            let cfg = {
                ext: params.ext || null,
                type: params.type || ''
            }

            if (Env.isIOSApp) {
                cfg = Object.assign(cfg, {
                    share_url: conf.url,
                    share_icon_url: conf.icon,
                    share_title: conf.title,
                    share_content: conf.desc
                })
                return ['share_weixin_appmsg', JSON.stringify(cfg), noop]
            } else if (Env.isAndroidApp) {
                cfg = Object.assign(cfg, {
                    url: conf.url,
                    imageUrl: conf.icon,
                    title: conf.title,
                    descript: conf.desc,
                    isFriendCircle: false
                })
                return ['callWXShare', cfg, noop]
            }
        }
    },

    shareWeixinTimeline: {
        alias: 'weixinTimeline|shareWeixinTimeline|share_weixin_timeline|weixin_timeline',
        support: '0.0.0',
        prepare: function (params, cb) {
            let conf = {
                url: params.url || params.share_url,
                icon: params.icon || params.icon_url || params.share_icon_url || params.imageUrl,
                title: params.title || params.share_title,
                desc: params.desc || params.content || params.share_content || params.descript
            }
            let cfg

            if (Env.isIOSApp) {
                cfg = {
                    share_url: conf.url,
                    share_icon_url: conf.icon,
                    share_title: conf.title,
                    share_content: conf.desc
                }
                return ['share_weixin_timeline', JSON.stringify(cfg), noop]
            } else if (Env.isAndroidApp) {
                cfg = {
                    url: conf.url,
                    imageUrl: conf.icon,
                    title: conf.title,
                    descript: conf.desc,
                    isFriendCircle: true
                }
                return ['callWXShare', cfg, noop]
            }
        }
    },
    shareSMS: {
        alias: 'share_sms|shareSms',
        support: '0.0.0',
        prepare: function (params, cb) {
            return ['share_sms', params, cb]
        }
    },
    launchScan: {
        support: '0.0.0',
        prepare: function (params, cb) {
            let fn = function (result) {
                let ret = typeof result === 'string' ? JSON.parse(result) : result
                cb(ret)
            }
            return ['launchScan', params, fn]
        }
    },
    scanQrCode: {
        support: '0.0.0',
        prepare: function (params, cb) {
            let fn = function (result) {
                let ret = typeof result === 'string' ? JSON.parse(result) : result
                cb(ret)
            }
            return ['scanQrCode', params, fn]
        }
    },
    initEntrance: {
        alias: 'init_entrance',
        support: '0.0.0',
        prepare: function (params, cb) {
            if (!params.buttons) {
                console.info('bridge warn: use buttons list instead of single object for initEntrance ,see http://wiki.intra.xiaojukeji.com//pages/viewpage.action?pageId=116169534')
            }
            return ['init_entrance', params, cb]
        }
    },
    invokeEntrance: {
        alias: 'share_slide_up|shareSlideUp|invoke_entrance',
        support: '0.0.0',
        prepare: function (params, cb) {
            return ['share_slide_up', params, cb]
        }
    },
    hideEntrance: {
        // name: 'hide_entrance',
        alias: 'hide_entrance',
        support: [{type: 'android', version: '2.4.4'}],
        prepare: function (params, cb) {
            return ['hide_entrance', params, cb]
        }
    },
    showEntrance: {
        alias: 'show_entrance',
        support: [{type: 'android', version: '2.4.4'}],
        prepare: function (params, cb) {
            return ['show_entrance', params, cb]
        }
    },
    startCarRequest: {
        alias: 'driverOut|driver_out',
        support: '0.0.0', // kfI-done
        prepare: function (params, cb) {
            let fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }
                cb(result)
            }
            return ['driver_out', {}, fn]
        }
    },
    toHomePage: {
        alias: 'toMainPage',
        support: '0.0.0',
        prepare: function (params, cb) {
            return ['toMainPage', params, cb]
        }
    },
    closePage: {
        // name: 'page_close',
        alias: 'page_close|pageClose',
        support: '0.0.0',
        prepare: function (params, cb) {
            return ['page_close', params, cb]
        }
    },
    chooseContact: {
        // name: 'readPhoneContact',
        alias: 'getContact',
        support: [{type: 'android', version: '2.4.4'}],
        prepare: function (params, cb) {
            return ['readPhoneContact', params, cb]
        }
    },
    photograph: {
        support: '0.0.0'
    },
    chooseImage: {
        support: '0.0.0'
    },
    orderDetailInfo: {
        support: '0.0.0'
    },
    orderReassignState: {
        support: [{type: 'ios', version: '2.4.4'}]
    },
    checkOrderDetail: {
        support: '0.0.0'
    },
    orderTripEnd: {
        support: '0.0.0',
        prepare: function (params, cb) {
            let fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }
                cb(result)
            }
            return ['orderTripEnd', params, fn]
        }
    },
    getUserInfo: {
        support: '0.0.0', //  kfI-done
        prepare: function (params, cb) {
            const BRIDGE_TIMEOUT = 2000
            let fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }
                const data = {
                    phone: result.phone,
                    ticket: result.ticket
                }
                cb(data)
            }
            // 300ms内没有返回就callback
            const wrappedFn = onceIn(fn, BRIDGE_TIMEOUT)
            return ['getUserInfo', {}, wrappedFn]
        }
    },
    getSystemInfo: {
        support: '0.0.0', // kfI-done
        prepare: function (params, cb) {
            let fn = function (result) {
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }
                console.log('JSON.parse', result)
                result.a3 = result.a3 || result.a3_token || ''
                result.deviceid = result.deviceid || ''
                result.vcode = result.vcode || ''
                result.os = result.os || ''
                cb(result)
            }
            // android native从5.1.0起开始支持getSystemInfo方法
            if (Env.isAndroidApp && compareVersion('<5.1.0')) {
                handle('getDeviceMarkInfo', params, function (res) {
                    // 下面使 android getDeviceMarkInfo 与 ios getSystemInfo 返回参数对齐
                    res.a3 = res.a3 || res.a3_token || ''
                    res.deviceid = res.deviceid || ''
                    res.vcode = res.vcode || ''
                    res.os = res.os || ''
                    cb(res)
                })
            } else {
                return ['getSystemInfo', params || {}, fn]
            }
        }
    },
    getDeviceMarkInfo: {
        support: '0.0.0'
    },
    getLocationInfo: {
        support: '0.0.0', // kfI-done
        prepare: function (params, cb) {
            let fn = function (result) {
                let r = {}
                // iOS返回的是字符串
                result = typeof result === 'string' ? JSON.parse(result) : result
                r = Object.assign(result, {
                    cityId: result.city_id
                })
                cb(r)
            }
            return ['getLocationInfo', params || {}, fn]
        }
    },
    // 调起导航kf一期不支持
    // launchNav: {
    //     support: '0.0.0'
    // },
    addCornerButton: {
        support: '0.0.0',
        prepare: function (params, cb) {
            // 重置回调名，避免覆盖的可能
            let jsCall = '' + params.jsCallback + new Date().getTime()
            params.jsCallback = jsCall
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb)
                } else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb)
                    })
                }
            } else if (Env.isAndroidApp) {
                window[jsCall] = cb
            }
            return ['addCornerButton', params, noop]
        }
    },
    resetBack: {
        support: '0.0.0' // kfI-done
    },
    getHydraData: {
        support: '0.0.0',
        prepare: function (params, cb) {
            let fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }
                cb(result)
            }
            return ['getHydraData', {}, fn]
        }
    },
    requestLogout: {
        alias: 'exitLogin',
        support: '0.0.0',
        prepare: function (params, cb) {
            return ['exitLogin', params, cb]
        }
    },
    openPage: {
        support: '0.0.0' // kfI-done
    },
    wxPayRequest: {
        support: '0.0.0'
    },
    openUniPay: {
        support: '1.1.18', // support universal payment after version 1.1.18
        prepare: function (params, cb) {
            return ['openUniPay', params, cb]
        }
    },
    open19PayPage: {
        support: '0.0.0',
        prepare: function (params, cb) {
            let fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }
                cb(result)
            }
            return ['open19PayPage', params, fn]
        }
    },
    commonPay: {
        support: '0.0.0',
        prepare: function (params, cb) {
            let fn = function (result) {
                let ret
                if (typeof result === 'string') {
                    ret = JSON.parse(result)
                } else {
                    ret = result
                }
                cb(ret)
            }
            if (params.type === 'weixin') {
                return ['wxPayRequest', params.pay_params, fn]
            } else if (params.type === 'ali') {
                return ['aliPayRequest', {'pay_string': params.pay_params}, fn]
            }
        }
    },
    viewIsBackground: {
        support: '0.0.0',
        prepare: function (params, cb) {
            // ios 无法保存回调函数，通过registerHandler注册一个函数来保存
            if (Env.isIOSApp) {
                let jsCall = 'viewIsBackground' + new Date().getTime()
                params.jsCallback = jsCall
                let fn = function (result) {
                    if (typeof result === 'string') {
                        let ret = JSON.parse(result)
                        cb(ret)
                    }
                }
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, fn)
                } else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, fn)
                    })
                }
                return ['viewIsBackground', params, noop]
            } else if (Env.isAndroidApp) {
                return ['viewIsBackground', params, cb]
            }
        }
    },

    setTitle: {
        alias: 'controllerTitle',
        support: '0.0.0', // kfI-done
        prepare: function (params, cb) {
            return ['controllerTitle', params, cb]
        }
    },
    launchIm: {
        support: '0.0.0'
    },
    showImEntrance: {
        support: '0.0.0'
    },
    faceRecognize: {
        support: '0.0.0', // kfI-done
        prepare: function (params, cb) {
            let fn = function (res) {
                if (typeof res === 'string') {
                    res = JSON.parse(res)
                }
                cb(res)
            }
            return ['faceRecognize', params, fn]
        }
    },
    controlBackPress: {
        support: '0.0.0', // kfI-done
        prepare: function (params, cb) {
            if (Env.isAndroidApp) {
                if (params.type === 'request') {
                    return ['requestBackPressedControl', params, cb]
                } else if (params.type === 'cancel') {
                    return ['cancelBackPressedControl', params, cb]
                }
            } else if (Env.isIOSApp) {
                let jsCall = 'controlBackPress' + new Date().getTime()
                params.jsCallback = jsCall
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb)
                } else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb)
                    })
                }
                return ['controlBackPress', params, noop]
            }
        }
    },
    resizeImage: {
        support: [{type: 'android', version: '2.4.4'}]
    },
    getA3Token: {
        support: '0.0.0',
        prepare: function (params, cb) {
            let fn = function (result) {
                let r = {}

                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }

                if (support('getSystemInfo')) {
                    // iOS只能从getSystemInfo方法中取imei
                    handle('getSystemInfo', {}, function (res) {
                        // iOS返回的是字符串
                        if (typeof res === 'string') {
                            res = JSON.parse(res)
                        }
                        // android返回a3_token，iOS返回a3
                        r.a3 = result.a3_token || result.a3 || ''
                        r.imei = res.imei || ''
                        cb(r)
                    })
                } else {
                    r.a3 = result.a3_token || result.a3 || ''
                    r.imei = result.imei || ''
                    cb(r)
                }
            }
            return ['getDeviceMarkInfo', {}, fn]
        }
    },
    shareFacebook: {
        support: '0.0.0',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params
            return ['shareFacebook', params, cb]
        }
    },
    shareLine: {
        support: '0.0.0',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params
            return ['shareLine', params, noop]
        }
    },
    shareWhatsApp: {
        support: '0.0.0',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params
            return ['shareWhatsApp', params, noop]
        }
    },

    shareTwitter: {
        support: '0.0.0',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params
            return ['shareTwitter', params, noop]
        }
    },
    shareEmail: {
        support: '0.0.0',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params
            return ['shareEmail', params, noop]
        }
    },
    shareFBMessenger: {
        support: '0.0.0',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params
            return ['shareFBMessenger', params, noop]
        }
    },
    startRecord: {
        support: '0.0.0',
        prepare: function (params) {
            let {voiceLocalFinish, voiceUploadFinish, ...rest} = params

            if (Env.isIOSApp) {
                window.DidiJSBridge.registerHandler('voiceLocalFinish', voiceLocalFinish)
                window.DidiJSBridge.registerHandler('voiceUploadFinish', voiceUploadFinish)
            } else if (Env.isAndroidApp) {
                window.didi = window.didi || {}
                window.didi.bridge = window.didi.bridge || {}
                window.didi.bridge._callback = (data) => {
                    let result = {}
                    try {
                        result = JSON.parse(data.data)
                    } catch (e) {}
                    if (data && data.handlerName === 'voiceLocalFinish') {
                        voiceLocalFinish(result)
                    } else if (data && data.handlerName === 'voiceUploadFinish') {
                        voiceUploadFinish(result)
                    }
                }
            } else {
                throw new Error('Bridge error: This page is not in a driver.')
            }

            return ['startRecord', rest, noop]
        }
    },
    callPassengerPhone: {
        support: '0.0.0',
        prepare: function (params, cb) {
            let hasExecuted = false
            let flag = false
            let fn = function (result) {
                flag = true
                if (hasExecuted) return
                hasExecuted = true
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }
                cb(result)
            }
            // 200ms内没有返回正常结果，则返回{}
            if (Env.isApp) {
                setTimeout(() => {
                    if (!flag) {
                        let data = {}
                        cb(data)
                    }
                }, 2000)
            }
            return ['callPassengerPhone', params, fn]
        }
    },
    doInterceptVerify: {
        support: '0.0.0',
        prepare: function (params, cb) {
            let hasExecuted = false
            let flag = false
            let fn = function (result) {
                flag = true
                if (hasExecuted) return
                hasExecuted = true
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }
                cb(result)
            }
            // 200ms内没有返回正常结果，则返回{}
            if (Env.isApp) {
                setTimeout(() => {
                    if (!flag) {
                        let data = {}
                        cb(data)
                    }
                }, 5000)
            }
            return ['doInterceptVerify', params, fn]
        }
    },
    endRecord: {
        support: '0.0.0'
    },
    playVoice: {
        support: '0.0.0'
    },
    stopVoice: {
        support: '0.0.0'
    },
    addFee: {
        support: '0.0.0'
    },
    confirmProtocol: {
        support: '0.0.0'
    },
    checkRecordPermis: {
        support: '0.0.0'
    },
    requestRecordPermis: {
        support: '0.0.0'
    },
    openPermisSettingPage: {
        support: '0.0.0'
    },
    closeCarRequest: {
        support: '0.0.0',
        prepare: function (params, cb) {
            var fn = function (result) {
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }
                cb(result)
            }
            return ['closeCarRequest', params, fn]
        }
    },
    statisticsPageLoadTime: {
        support: '0.0.0',
        prepare: function (params, cb) {
            return ['statisticsPageLoadTime', params, cb]
        }
    },
    unioneOrderOfflinePay: {
        support: '0.0.0',
        prepare: function (params, cb) {
            let fn = function (result) {
                let ret = typeof result === 'string' ? JSON.parse(result) : result
                cb(ret)
            }
            return ['unioneOrderOfflinePay', params, fn]
        }
    },
    showCommendRobot: {
        support: '0.0.0',
        prepare: function (params, cb) {
            // 重置回调名，避免覆盖的可能
            return ['showCommendRobot', params]
        }
    },
    saveImage: {
        support: '1.0.10',
        prepare: function (params, cb) {
            return ['saveImage', JSON.stringify(params), cb]
        }
    },
    callUpVoIP: {
        support: '1.1.18',
        prepare: function (params, cb) {
            // 重置回调名，避免覆盖的可能
            let jsCall = '' + params.jsCallback + new Date().getTime()
            params.jsCallback = jsCall
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb)
                } else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb)
                    })
                }
                return ['callUpVoIP', params, noop]
            } else if (Env.isAndroidApp) {
                window[jsCall] = cb
            }
            return ['callUpVoIP', params, cb]
        }
    },
    launchWeChatMiniApp: {
        support: '1.1.18',
        prepare: function (params, cb) {
            if (Env.isIOSApp) {
                return ['launchWeChatMiniApp', params, cb]
            }
            return ['launchWeChatMiniApp', JSON.stringify(params), cb]
        }
    },
    callNativeBizLogin: {
        support: '1.3.10',
        prepare: function (params, cb) {
            if (!params.biz_id) {
                console.info('bridge warn: biz_id is required ,see http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=599205580')
            }
            let fn = function (result) {
                let ret = typeof result === 'string' ? JSON.parse(result) : result
                cb(ret)
            }
            return ['callNativeBizLogin', JSON.stringify(params), fn]
        }
    },
    isBizLogin: {
        support: '1.3.10',
        prepare: function (params, cb) {
            if (!params.biz_id) {
                console.info('bridge warn: biz_id is required ,see http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=599205580')
            }
            let fn = function (result) {
                let ret = typeof result === 'string' ? JSON.parse(result) : result
                cb(ret)
            }
            return ['isBizLogin', JSON.stringify(params), fn]
        }
    },
    finishCancellation: {
        support: '1.3.10',
        prepare: function (params, cb) {
            if (!params.isCancel || !params.isNeedLogin) {
                console.info('bridge warn: isCancel and isNeedLogin is required ,see http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=603615338')
            }
            let fn = function (result) {
                let ret = typeof result === 'string' ? JSON.parse(result) : result
                cb(ret)
            }
            return ['finishCancellation', JSON.stringify(params), fn]
        }
    }
}
